let list = [
    {
        path: '/dev',
        component: () => import('./index.vue'),
        redirect: '/dev/form',
        children:[
            {

                path: 'form',
                component: () => import('./form/index.vue'),
            },
            {

                path: 'dictionaries',
                component: () => import('./dictionaries/index.vue'),
            },
        ]
    }
];

export default DEV ? list : [];